(() => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  const base = window.Shopify?.routes?.root || '/';
  const open = async () => {
    await customElements.whenDefined('cart-drawer');
    const trigger = document.activeElement?.closest('.cv-menu-drawer') ? document.querySelector('.cv-cart-link') : document.activeElement;
    document.querySelectorAll('.cv-menu-drawer[open]').forEach(menu => menu.close());
    drawer.show(trigger);
    await drawer.onCartRefresh({detail:{open:true,animate:true}});
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || drawer.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === `${base}cart` && !url.search) { event.preventDefault(); open(); }
  });
  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-pw-explore]')) document.querySelector('.cv-product')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    if (event.target.closest('[data-dismiss-info-dialog]')) event.target.closest('dialog')?.close();
  });
  window.PortwellCart = {open};
})();
